import useScrollToTop from '../hooks/use-scroll-to-top.js';

const ScrollToTop = () => {
	useScrollToTop();
	return null;
};

export default ScrollToTop;
